<div id="message">
  <img id="image_app" src="../assets/favicon.png" alt="Icon App">
  <a [href]="link">{{ goToLink }}</a>
  <!--<a *ngIf="showStore" id="copy_link" (click)="copy()" [href]="storeLink">{{ goToLinkStore }}</a>-->
</div>